import { Injectable } from '@angular/core';

@Injectable()

export class BackRestrict {
    
    clearBrowserBackHistory(): void {
        history.pushState(null, null, location.href);
        window.onpopstate = function (event) {
          history.go(1);
        };
      }   
}
